import Vue from "vue"

import("../public/common.css")
require("./mq")

///

import BootstrapVue from "bootstrap-vue"

Vue.use(BootstrapVue)
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"

///

import VueRouter from "vue-router"
Vue.use(VueRouter)

// V1 Site:
//import Landing          from "./pages/Landing.vue"
//import About            from "./pages/About.vue"
//import Products         from "./pages/Products.vue"
//import Sandbox          from "./pages/Sandbox.vue"
//import Articles         from "./pages/Articles.vue"
//import ArticleDetail    from "./pages/ArticleDetail.vue"

import Posts            from "./assets/posts"

// V2 Site:
import LandingV2        from "./pages/V2/LandingV2.vue"
import PlaytestV2       from "./pages/V2/PlaytestV2.vue"
import BugV2            from "./pages/V2/BugV2.vue"
import MissionV2        from "./pages/V2/MissionV2.vue"
import TeamV2           from "./pages/V2/TeamV2.vue"
import NewsV2           from "./pages/V2/NewsV2.vue"
import PostV2           from "./pages/V2/PostV2.vue"
import TermsV2          from "./pages/V2/TermsV2.vue"
import PrivacyV2        from "./pages/V2/PrivacyV2.vue"

// V3 site
//import LandingV3        from "./pages/V3/LandingV3.vue"
//import PostV3           from "./pages/V3/PostV3.vue"

const posts =
  Posts.filter(function(entry){
    return entry.disabled == undefined;
  }).map(function(entry){
    return {
      path: entry.path,
      component: () => import(`@/posts/${entry.path}.md`)
    }
  })

const routes = [
  // V1 site:
  //{ path: "/",                    component: Landing },
  //{ path: "/about",               component: About },

  //{ path: "/products",            component: Products },
  //{ path: "/sandbox",             component: Sandbox },

  //{ path: "/articles",            component: Articles },
  //{ path: "/article",             component: ArticleDetail,
  //                                children: posts     },

  // V2 site
  { path: "/",                 component: LandingV2 },
  { path: "/playtest",         component: PlaytestV2 },
  { path: "/support",          component: BugV2 },
  { path: "/mission",          component: MissionV2 },
  { path: "/team",             component: TeamV2    },
  { path: "/news",             component: NewsV2    },
  { path: "/post",             component: PostV2,
                               children: posts      },
  { path: "/terms",            component: TermsV2   },
  { path: "/privacy",          component: PrivacyV2 },

  // V3 site:
  //{ path: "/",                  component: LandingV3 },
  //{ path: "/post",              component: PostV3,
  //                              children: posts      },
  //{ path: "/support",           component: BugV2     }
]

const router = new VueRouter({
  mode : "history",
  routes : routes,

  scrollBehavior (to, from, savedPosition) {
    if(to.hash)
      return {selector: to.hash}

    else if (savedPosition)
      return savedPosition

    return { x: 0, y: 0 }
  }
})

new Vue({
  router : router
}).$mount("#app")
